import { Alert } from './Alert'
import { Avatar } from './Avatar'
import { Badge } from './Badge'
import { Button } from './Button'
import { Card } from './Card'
import { Checkbox } from './Checkbox'
import { Form } from './Form'
import { FormError } from './FormError'
import { FormLabel } from './FormLabel'
import { Heading } from './Heading'
import { Input } from './Input'
import { Link } from './Link'
import { LoadingSpinner } from './LoadingSpinner'
import { Menu } from './Menu'
import { Modal } from './Modal'
import { Select } from './Select'
import { SkipLink } from './SkipLink'
import { Slider } from './Slider'
import { Switch } from './Switch'
import { Text } from './Text'
import { Textarea } from './Textarea'

export const components = {
  Alert,
  Avatar,
  Badge,
  Button,
  Card,
  Checkbox,
  Form,
  FormError,
  FormLabel,
  Heading,
  Input,
  Link,
  Menu,
  Modal,
  Select,
  SkipLink,
  Slider,
  Spinner: LoadingSpinner,
  Switch,
  Text,
  Textarea,
}
